{
  "enum": {
    "IxfDocumentsV1DocumentStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxfDocumentsV1DocumentQueryServiceDocumentListFilterableFields": {
      "accountId": "Account",
      "data": {
        "spec": {
          "createdAt": "Created At",
          "endDate": "End Date",
          "startDate": "Start Date",
          "type": {
            "!type": "Type"
          }
        }
      },
      "documentId": "Document",
      "programId": "Program",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxfDocumentsV1DocumentEventType": {
      "replaced": "Replaced",
      "uploaded": "Uploaded"
    },
    "IxfDocumentsV1DocumentType": {
      "accountStatement": "Account Statement",
      "directDepositInstructions": "Direct Deposit Instructions",
      "taxDocument": "Tax Form",
      "tradeConfirmation": "Trade Confirmation"
    }
  },
  "sortEnum": {
    "IxfDocumentsV1DocumentQueryServiceDocumentListSortableFields": {
      "data": {
        "spec": {
          "createdAt": "Created At",
          "endDate": "Data Spec End Date",
          "startDate": "Data Spec Start Date"
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}